<div class="lnb_inner">
    <div class="lnb_user" *ngIf="isAdmin">
        <span class="lnb_user_img">OASIS</span>
        <span class="lnb_user_name">관리자</span>
        <span class="lnb_user_id">{{userId}}</span>
    </div>
    <ul class="lnb_list lnb_list-depth1">
        <ng-container  *ngFor="let group of menuGroupList">
            <li *ngIf="group.isHome" class="lnb_depth_title lnb_list-00" [ngClass]="group.isOpen ? 'active' : ''">
                <a (click)="selectMenu(group, null)">HOME</a>
            </li>
            <li *ngIf="!group.isHome" class="lnb_depth_title lnb_depth-toggle {{group.iconClass}} " [ngClass]="group.isOpen ? 'open' : ''">
                <a (click)="toggleGroup(group)">{{group.name}}</a>
                <ng-container  *ngFor="let menu of group.list">
                    <ul class="lnb_list lnb_list-depth2">
                        <li [ngClass]="menu.isActive ? 'active' : ''"><a (click)="selectMenu(group, menu)">{{menu.name}}</a></li>
                    </ul>
                </ng-container>
            </li>
        </ng-container>
    </ul>
</div>